import moment from "moment";
var date = new Date();
var y_date = date.getDate();
export default function Yesterdays_date() {
    return date.setDate(y_date - 1);
}
export var nextWorkingDay = function () {
    if (moment().day() === 5) {
        // friday, show monday
        // set to monday
        return moment().weekday(8);
    }
    if (moment().day() === 6) {
        // saturday, show monday
        // set to monday
        return moment().weekday(8);
    }
    else {
        // other days, show next day
        return moment().add("days", 1);
    }
};
